import Vue from './vue';
import path from 'path';
import eqNode from 'eqnode';

import * as chartCommon from './libraries/charts/chartCommon';
import * as file from './libraries/file'; import './libraries/extensions/array';
import './libraries/extensions/string';
import './libraries/extensions/number';

import './plugins/directives';
import './plugins/matomo';

import Notifications from 'vue-notification'
import VuePageTitle from 'vue-page-title';
import { chartConfig } from './libraries/charts';
import './assets/hvh-scss/globals.scss';
import './assets/scss/globals.scss';
import '@mdi/font/css/materialdesignicons.css';
import './assets/css/suiss-intl-fonts.css';
import router from './router';
import store from './store';
import ActicsLandingPage from './views/actics/ActicsLandingPage.vue';
import * as liveFiltersStatic from './libraries/liveFilters';
import Loader from './components/common/loader/Loader.vue';
import { getCriteriaPillTitle, getEventValueLabel, getCriteriaCode, getCriteriaSentance } from './libraries/criteria';
import { launchDarklyClient } from './libraries/launchDarkly';
import * as common from './libraries/common';
import { baseApiUrl } from './axios.js';
import { confirmClinicalVerification } from './libraries/cohorts.js';

Vue.use(Notifications);

Vue.component('Loader', Loader);

const requireView = require.context('./views', true, /[A-Z]\w+\.vue$/);
const requireComponent = require.context('./components', true, /[A-Z]\w+\.vue$/);

[requireView, requireComponent].forEach(req => {
  req.keys()
    .forEach((fileName) => {
      const baseName = path.basename(fileName, '.vue');

      let component = req(fileName);
      component = component.default || component;
      if (!component.noExport) {
        const componentName = component.name || baseName;
        Vue.component(componentName, component);

        var slashedName = common.joinSingleStrings(componentName.splitByUpperCase())
          .join('-')
          .toLowerCase();
        Vue.component(slashedName, component);
      }
    });
});
Vue.use(VuePageTitle, { suffix: ' - ClientAnalytics' });

Vue.prototype.generateSymbols = num => {
  const symbols = Object.values(chartConfig.symbols);
  return new Array(Math.ceil(num / symbols.length)).fill(0)
    .flatMap(() => symbols)
    .filter((_, ind) => ind < num);
};
Vue.prototype.$loadImage = path => path;
Vue.prototype.$baseUrl = '/';

global.HVH = {
  ...(global.HVH || {}),
  ...chartCommon,
  ...file,
  ...common,
  eqNode,
  dpd: {
    getCriteriaPillTitle,
    getEventValueLabel,
    getCriteriaCode,
    getCriteriaSentance,
  },
  cohorts: {
    confirmClinicalVerification,
  },
  liveFiltersStatic,
  baseApiUrl,
};

router.addRoutes([{
  path: '/',
  name: 'acticsLandingPage',
  component: ActicsLandingPage,
}]);

window['router'] = router;
window['store'] = store;
window['launchDarklyClient'] = launchDarklyClient;
